import React, { FC } from 'react';

type Props = {
  name: string;
  className?: string;
};

export const MaterialIcon: FC<Props> = ({ name, className = '' }) => (
  <i className={`material-icons icons__${name} ${className}`} />
);
